import { Asset } from '../../../queries/ats/titles/types/asset';
import { DetailsViewLoaderProps } from './details-view-loader';

interface DetailsViewWrapperProps extends Pick<DetailsViewLoaderProps, 'before' | 'after'> {
  children: React.ReactNode;
  asset: Asset | undefined;
}

export function DetailsViewWrapper({ children, asset, before, after }: DetailsViewWrapperProps) {
  return (
    <>
      <RenderPropComponent<Asset> data={asset} render={before} />
      {children}
      <RenderPropComponent<Asset> data={asset} render={after} />
    </>
  );
}

interface RenderPropComponentProps<T> {
  data: T | undefined;
  render: (((data: T | undefined) => JSX.Element) | JSX.Element) | undefined;
}

function RenderPropComponent<T>({ data, render }: RenderPropComponentProps<T>) {
  if (typeof render === 'function') {
    return render(data);
  }

  return <>{render}</>;
}
